import {BaseModel} from './base';

export class FlashMessage extends BaseModel {
  type = '';

  title = '';

  message = '';

  options = {};

  constructor(type, title, message, options) {
    super();
    this.type = type;
    this.title = title;
    this.message = message;
    this.options = options;
  }
}
